import { useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchUnreadMessageCount } from "../reducers/notification/notificationAction";
import { RootState } from "../reducers/rootReducer";
import { selectHasFSPAccess } from "../reducers/session/sessionSelectors";

export const useUnreadMessageCount = () => {
  const sessionId = useSelector((state: RootState) => state.session.sessionId);
  const hasFSPAccess = useSelector(selectHasFSPAccess);

  useEffect(() => {
    if (!sessionId || !hasFSPAccess) return;

    fetchUnreadMessageCount();

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        fetchUnreadMessageCount();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [sessionId, hasFSPAccess]);
};
